import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@ui/components';
import { Button, Dialog } from '@ui/components';
import { DialogContent } from '@ui/components';
import { DialogClose } from '@ui/components';
import { FC } from 'react';

import { useBulkRemoveVehicleDialog } from './use-bulk-remove-vehicle-dialog';

export const BulkRemoveVehicleDialog: FC<{
  onClose: (value: { handleSubmit: boolean }) => void;
  isOpen: boolean;
  ids: string[];
}> = ({ ids, onClose, isOpen }) => {
  const { removeVehicle, isPending, t } = useBulkRemoveVehicleDialog(() =>
    onClose({ handleSubmit: true }),
  );

  if (!ids.length) return null;

  return (
    <Dialog onOpenChange={() => onClose({ handleSubmit: false })} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('VEHICLES.BULK_REMOVE_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('VEHICLES.BULK_REMOVE_DIALOG_DESCRIPTION')}</DialogDescription>
        <DialogFooter className="flex items-center justify-between gap-4">
          <DialogClose asChild>
            <Button variant="tertiary" wide>
              {t('VEHICLES.BULK_REMOVE_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => ids.length > 0 && removeVehicle(ids)}
            isLoading={isPending}
            variant="primary"
            wide
          >
            {t('VEHICLES.BULK_REMOVE_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
